import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import Project from 'src/app/interfaces/Project';
import { UserService } from 'src/app/services/user.service';
import { ProjectService } from 'src/app/services/project.service';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-projects',
  templateUrl: './projects.component.html',
  styleUrls: ['./projects.component.scss'],
})
export class ProjectsComponent implements OnInit, OnDestroy {
  subscriptions: Subscription = new Subscription();
  user;
  locked = false;
  search = {
    term: '',
    isFocused: false,
  };
  projects: Array<Project> = [];
  filteredProjects: Array<Project> = [];
  params = null;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private projectService: ProjectService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {
    this.analyticsService.event('project_view');
    this.subscriptions.add(
      this.userService.user.subscribe((u) => {
        if (u && u.uid) {
          this.user = u;
          this.locked = false;
          this.getProjects();
        } else {
          this.locked = true;
        }
      })
    );
  }

  getProjects() {
    this.subscriptions.add(
      this.projectService.getProjects().subscribe(
        (projArr) => {
          this.projects = projArr;
          this.filteredProjects = this.projects;
          projArr.forEach((p) => {
            if (p.projectName === null) {
              this.projectService.deleteProject(p.id).then(() => console.warn('deleted an empty project'));
            }
          });
        },
        (e) => console.error(e)
      )
    )
  }

  filterChange(f) {
    this.filteredProjects = f.filteredList;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
